import { Tabs } from "antd";
import React from "react";
import { Link } from "react-router-dom";
import { strings } from "../../helpers";
import DoctorBasicInfoContainer from "../DoctorDetailsComponents/BasicInfo/DoctorBasicInfoContainer";
import ClinicsContainer from "../DoctorDetailsComponents/Clinics/ClinicsContainer";
import DoctorDetailContainer from "../DoctorDetailsComponents/ClinicDoctor/DoctorDetailContainer";

const { TabPane } = Tabs;

export default class DoctorDetailsTabView extends React.Component {
  render() {
    const { currentPath, doctorId, clinicDocId, clinicId } = this.props;

    const basicInfo = `/doctor-details/${doctorId}/basic-details${
      clinicId ? `/${clinicId}` : ""
    }${clinicDocId ? `/${clinicDocId}` : ""}`;
    const clinics = `/doctor-details/${doctorId}/clinics${
      clinicId ? `/${clinicId}` : ""
    }${clinicDocId ? `/${clinicDocId}` : ""}`;
    const clinicDoctor = `/doctor-details/${doctorId}/clinic-doctor${
      clinicId ? `/${clinicId}` : ""
    }${clinicDocId ? `/${clinicDocId}` : ""}`;

    return (
      <div className="kc-tabs-view appointment-content-container">
        <Tabs
          type="card"
          className="px-10 line-tabs"
          activeKey={
            currentPath === "basic-details" ? "basic-details" : currentPath
          }
        >
          <TabPane
            key="basic-details"
            tab={<Link to={basicInfo}>Doctor profile</Link>}
          >
            <DoctorBasicInfoContainer onlyDoctors doctorId={doctorId} />
          </TabPane>
          {clinicDocId && clinicId && (
            <TabPane
              key="clinic-doctor"
              tab={<Link to={clinicDoctor}>Clinic doctor profile</Link>}
            >
              <DoctorDetailContainer
                clinicDocId={clinicDocId}
                clinicId={clinicId}
              />
            </TabPane>
          )}
          <TabPane key="clinics" tab={<Link to={clinics}>Clinics</Link>}>
            <ClinicsContainer doctorId={doctorId} />
          </TabPane>
        </Tabs>
      </div>
    );
  }
}
